import React from 'react';

export function useKeyPress(targetKey, cbOnKeyUp, cbOnKeyDown) {
    const [keyPressed, setKeyPressed] = React.useState(false);

    function downHandler(event) {
        if (event.key === targetKey) {
            setKeyPressed(true);
            cbOnKeyDown && cbOnKeyDown(event);
        }
    }

    const upHandler = event => {
        if (event.key === targetKey) {
            setKeyPressed(false);
            cbOnKeyUp && cbOnKeyUp(event);
        }
    };

    React.useEffect(() => {
        window.addEventListener('keydown', downHandler);
        window.addEventListener('keyup', upHandler);
        return () => {
            window.removeEventListener('keydown', downHandler);
            window.removeEventListener('keyup', upHandler);
        };
    }, []);

    return keyPressed;
}
